module.exports = __webpack_public_path__ + "img/logo.22f32b5d.png";